// Action types
export const SET_RESIZE = 'layout/SET_RESIZE';

// Action creators
export const setViewportSize = (payload: { viewportWidth: number; viewportHeight: number; screenWidth: number; screenHeight: number }) => ({
  type: SET_RESIZE,
  payload
});
